type PianoError = {
  error_code_list: {
    message: string;
    code?: number;
    field_name?: string;
  }[];
};

type CreateAccountApiSuccess = {
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: number;
  registration: true;
  email_confirmation_required: boolean;
  pre_confirmed_user: boolean;
  extend_expired_access_enabled: boolean;
};

export type CreateAccountApiResponse = CreateAccountApiSuccess | PianoError;

export const isCreateAccountApiSuccess = (response: CreateAccountApiResponse): response is CreateAccountApiSuccess => {
  return (response as CreateAccountApiSuccess).access_token !== undefined;
};

interface RegisterSuccessResponse extends CreateAccountApiSuccess {
  success: true;
  status?: string;
  subStatus?: string;
}

interface RegisterFailureResponse {
  success: false;
  message: string;
  isZeroBounceError: boolean;
}

export const isRegisterFailureResponse = (response: RegisterResponse): response is RegisterFailureResponse => {
  return (response as RegisterFailureResponse).success === false;
};

export type RegisterResponse = RegisterSuccessResponse | RegisterFailureResponse;
